import React, { useState } from 'react';
import { useQueryParams } from './index';
import PropTypes from 'prop-types';
import cookieFactory from '../../cookieFactory';

export const UserUiConfigContext = React.createContext({
  userUiConfigState: {},
  setUserUiConfigState: () => {},
});

const setGridCookie = val => {
  const uiCookie = cookieFactory('ui-prod-grid-sort', { path: window.location.pathname, expires: 365 });
  if (uiCookie.get() !== val) {
    uiCookie.set(val);
  }
};

export const UserUiConfigProvider = ({ children }) => {
  const { params } = useQueryParams();
  const [userUiConfigState, setUserUiConfigState] = useState({
    productGridSort: params.uiProductGridSort || cookieFactory('ui-prod-grid-sort').get() || 'default',
  });

  if (params.uiProductGridSort) {
    setGridCookie(params.uiProductGridSort);
  }

  const setUserUiConfig = (newConfig) => {
    setUserUiConfigState({
      ...userUiConfigState,
      ...newConfig,
    });
    setGridCookie(newConfig.productGridSort);
  };

  return (
    <UserUiConfigContext.Provider value={{ userUiConfigState, setUserUiConfig }}>
      {children}
    </UserUiConfigContext.Provider>
  );
};

UserUiConfigProvider.propTypes = {
  children: PropTypes.node,
};
